import {
  GetByOwnerTasksRequestModel,
  GetByParentTasksRequestModel,
  GetByPerformerTasksRequestModel,
  GetByPriorityTasksRequestModel,
  GetByStatusTasksRequestModel,
  GetByTagTasksRequestModel,
  GetByTypeTasksRequestModel,
  GetTaskListRequestSortModel,
  GroupedTaskItemModel,
  GroupedTaskRequestModel,
  PageRequestModel,
  PageResponseModel,
  TaskAttachedFileModel,
  TaskModel,
  TaskMoveQueueRequestModel,
  TaskPersonModel,
  TaskPriorityModel,
  TaskQueueModel,
  TaskStatusModel,
  TaskTagModel,
  TaskTypeModel,
  TaskUpdatePriorityModel,
  TaskUpdateStatusModel,
  TaskUpdateTypeModel,
} from '../models';
import { TaskViewElementEnum } from '../enums';
import { TaskViewSettings } from '../types';
import GetGroupedByStatusTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetGroupedByStatusTaskListRequest';
import GetTaskListRequestVisibleSettings from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetTaskListRequestVisibleSettings';
import GetGroupedByStatusTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByStatusTaskListResponse';
import GetGroupedTaskListItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedTaskListItem';
import UserTaskItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UserTaskItem';
import GetGroupedByPriorityTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetGroupedByPriorityTaskListRequest';
import GetGroupedByPriorityTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByPriorityTaskListResponse';
import GetGroupedByPerformerTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByPerformerTaskListResponse';
import GetGroupedByOwnerTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetGroupedByOwnerTaskListRequest';
import GetGroupedByOwnerTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByOwnerTaskListResponse';
import GetGroupedByTagTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetGroupedByTagTaskListRequest';
import GetGroupedByTagTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByTagTaskListResponse';
import GetGroupedByTypeTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetGroupedByTypeTaskListRequest';
import GetGroupedByTypeTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetGroupedByTypeTaskListResponse';
import GetByStatusTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByStatusTaskListRequest';
import PageRequest from '@/api/Main/dataSource/api/pagination-helper/lib/PageRequest';
import GetByStatusTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByStatusTaskListResponse';
import GetByPriorityTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByPriorityTaskListRequest';
import GetByPriorityTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByPriorityTaskListResponse';
import GetByPerformerTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByPerformerTaskListRequest';
import GetByPerformerTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByPerformerTaskListResponse';
import GetByTagTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByTagTaskListRequest';
import GetByTagTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByTagTaskListResponse';
import GetByTypeTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByTypeTaskListRequest';
import GetByTypeTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByTypeTaskListResponse';
import GetByOwnerTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByOwnerTaskListRequest';
import GetByOwnerTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByOwnerTaskListResponse';
import GetTaskListRequestFilter from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskListRequestFilter';
import GetByParentTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByParentTaskListRequest';
import GetByParentTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByParentTaskListResponse';
import TaskUpdatePriorityRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdatePriorityRequest';
import TaskUpdateStatusRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdateStatusRequest';
import UpdateTaskTypeRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/UpdateTaskTypeRequest';
import ProjectNamespaceListResponse from '@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceListResponse';
import { NamespaceModel } from '@/pages/project-namespaces-page/components/namespace-card/models';
import DifficultyLevelTaskModel from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/DifficultyLevelTaskModel';
import GetWithoutGroupingTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetWithoutGroupingTaskListRequest';
import GetWithoutGroupingTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetWithoutGroupingTaskListResponse';
import ImportTypeEnum from '@/api/Main/dataSource/api/projects/task/data-context/enums/ImportTypeEnum';
import { TaskImportServiceEnum } from '@/enums';

const mapTaskImportService = (value: ImportTypeEnum): TaskImportServiceEnum | undefined => {
  switch (value) {
    case ImportTypeEnum.None:
      return;
    case ImportTypeEnum.Weeek:
      return TaskImportServiceEnum.Weeek;
  }
};

const mapPageRequest = (request: PageRequestModel) =>
  new PageRequest({
    Skip: request.Skip,
    Take: request.Take,
  });

const mapViewSettings = (viewSettings: TaskViewSettings) => {
  return new GetTaskListRequestVisibleSettings({
    VisibleOwner: viewSettings.viewElements.includes(TaskViewElementEnum.Author),
    VisiblePerformers: viewSettings.viewElements.includes(TaskViewElementEnum.Performers),
    VisibleObservers: viewSettings.viewElements.includes(TaskViewElementEnum.Observers),
    VisibleStatus: viewSettings.viewElements.includes(TaskViewElementEnum.Status),
    VisiblePriority: viewSettings.viewElements.includes(TaskViewElementEnum.Priority),
    VisibleType: viewSettings.viewElements.includes(TaskViewElementEnum.Type),
    VisibleFiles: viewSettings.viewElements.includes(TaskViewElementEnum.AttachedFiles),
    VisibleTags: viewSettings.viewElements.includes(TaskViewElementEnum.Tags),
    VisibleDateCreate: viewSettings.viewElements.includes(TaskViewElementEnum.DateCreate),
    VisibleDateEnd: viewSettings.viewElements.includes(TaskViewElementEnum.Deadline),
    // VisibleDifficulty: viewSettings.viewElements.includes(TaskViewElementEnum.Difficulty),
    // VisibleQueueTask: viewSettings.viewElements.includes(TaskViewElementEnum.Queue),
    VisibleSubtask: viewSettings.showNestedTasks,
  });
};

const mapSortingSettings = (sort: GetTaskListRequestSortModel) => {
  return new GetTaskListRequestSortModel({
    SortByDeadline: sort?.SortByDeadline,
    SortByDifficulty: sort?.SortByDifficulty,
    SortByPriority: sort?.SortByPriority,
    SortByEstimatedTime: sort?.SortByEstimatedTime,
    SortBySpentTime: sort?.SortBySpentTime,
  });
};

export const mapGetNamespacesResponse = (response: ProjectNamespaceListResponse) =>
  response.Items.map(
    (namespace) =>
      new NamespaceModel({
        Id: namespace.Id,
        Name: namespace.Name,
        IconId: namespace.IconId,
        IconUrl: namespace.IconUrl,
        ColorId: namespace.ColorId,
        Color: namespace.Color,
        TasksCount: namespace.TaskCount,
      }),
  );

export const mapTaskMoveQueueRequestModel = (request: TaskMoveQueueRequestModel) => {
  return new TaskMoveQueueRequestModel(request);
};

export const mapGetGroupedByStatusTaskListRequest = (request: GroupedTaskRequestModel) => {
  return new GetGroupedByStatusTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });
};

const mapUserTaskItem = (item: UserTaskItem) => {
  return new TaskPersonModel({
    Id: item.Id,
    FirstName: item.FirstName ?? 'Имя',
    LastName: item.LastName ?? 'Фамилия',
    MiddleName: item.MiddleName ?? 'Отчетсво',
    ImageUrl: item.Photo,
    NoPhotoColor: item.AvatarColor,
  });
};

const mapGetGroupedTaskListItem = (item: GetGroupedTaskListItem, parentId?: number) => {
  return new TaskModel({
    Id: item.Id,
    Author: item.Owner ? mapUserTaskItem(item.Owner) : undefined,
    Name: item.Name,
    Queues: item.QueueTaskList.map((q) => new TaskQueueModel(q)),
    Priority: item.Priority
      ? new TaskPriorityModel({
          Id: item.Priority.PriorityId,
          Name: item.Priority.PriorityName,
          Color: item.Priority.PriorityColor,
        })
      : undefined,
    Status: item.Status
      ? new TaskStatusModel({
          Id: item.Status.StatusId,
          Name: item.Status.StatusName,
          Color: item.Status.StatusColor,
        })
      : undefined,
    Performers: item.Performers ? item.Performers.map(mapUserTaskItem) : [],
    Observers: item.Observers ? item.Observers.map(mapUserTaskItem) : [],
    Tags: item.Tags
      ? item.Tags.map(
          (tag) =>
            new TaskTagModel({
              Id: tag.Id,
              Name: tag.TagName,
              Color: tag.Color || '#0AA4D4',
            }),
        )
      : [],
    AttachedFiles: item.Files
      ? item.Files.map(
          (file) =>
            new TaskAttachedFileModel({
              Id: file.Id,
              FileName: file.Name,
              FileExtension: '.asdadad', // TODO:
            }),
        )
      : [],
    DateCreate: item.DateCreate ? new Date(item.DateCreate + 'Z') : undefined,
    Deadline: item.DateEnd ? new Date(item.DateEnd + 'Z') : undefined,
    EstimateTime: item.Estimated,
    WorkTime: item.WorkingTime,
    Type: item.Type
      ? new TaskTypeModel({
          Id: item.Type.TypeId,
          Name: item.Type.TypeName,
        })
      : undefined,
    ParentTaskId: parentId,
    Difficulty: new DifficultyLevelTaskModel({
      DifficultyId: item?.DifficultyLevel?.DifficultyId,
      DifficultyName: item?.DifficultyLevel?.DifficultyName,
      DifficultyColor: item?.DifficultyLevel?.DifficultyColor,
    }),
    CurrentQueueSubtaskCount: item.CurrentQueueSubtaskCount,
    OtherQueueSubtaskCount: item.OtherQueueSubtaskCount,
    ImportService: mapTaskImportService(item.ImportType),
  });
};

export const mapGetGroupedByStatusTaskListResponse = (
  response: GetGroupedByStatusTaskListResponse,
) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Status: new TaskStatusModel({
        Id: item.StatusId,
        Name: item.StatusName,
        Color: item.StatusColor,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};

export const mapGetGroupedByPriorityTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetGroupedByPriorityTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetGroupedByPriorityTaskListResponse = (
  response: GetGroupedByPriorityTaskListResponse,
) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Priority: new TaskPriorityModel({
        Id: item.PriorityId,
        Name: item.PriorityName,
        Color: item.PriorityColor,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};

export const mapGetGroupedByPerformerTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetGroupedByPriorityTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetGroupedByPerformerTaskListResponse = (
  response: GetGroupedByPerformerTaskListResponse,
) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Performer: new TaskPersonModel({
        Id: item.Performer.Id,
        FirstName: item.Performer.FirstName ?? 'Имя',
        LastName: item.Performer.LastName ?? 'Фамилия',
        MiddleName: item.Performer.MiddleName ?? 'Отчетсво',
        ImageUrl: item.Performer.Photo,
        NoPhotoColor: item.Performer.AvatarColor,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};

export const mapGetGroupedByOwnerTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetGroupedByOwnerTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetGroupedByOwnerTaskListResponse = (
  response: GetGroupedByOwnerTaskListResponse,
) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Author: new TaskPersonModel({
        Id: item.Owner.Id,
        FirstName: item.Owner.FirstName ?? 'Имя',
        LastName: item.Owner.LastName ?? 'Фамилия',
        MiddleName: item.Owner.MiddleName ?? 'Отчетсво',
        ImageUrl: item.Owner.Photo,
        NoPhotoColor: item.Owner.AvatarColor,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};
export const mapGetGroupedByTagTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetGroupedByTagTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetGroupedByTagTaskListResponse = (response: GetGroupedByTagTaskListResponse) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Tag: new TaskTagModel({
        Id: item.TagId,
        Name: item.TagName,
        Color: item.TagColor,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};
export const mapGetGroupedByTypeTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetGroupedByTypeTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    ColumnTakeCount: request.ColumnTakeCount,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetWithoutGroupingTaskListRequest = (request: GroupedTaskRequestModel) =>
  new GetWithoutGroupingTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    Page: new PageRequest({
      Skip: 0,
      Take: request.ColumnTakeCount,
    }),
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetWithoutGroupingTaskListResponse = (
  response: GetWithoutGroupingTaskListResponse,
) => {
  return [
    new GroupedTaskItemModel({
      Id: `group-0`,
      Count: response.Page.Count,
      Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
    }),
  ];
};

export const mapGetGroupedByTypeTaskListResponse = (response: GetGroupedByTypeTaskListResponse) => {
  return response.Items.map((item, index) => {
    return new GroupedTaskItemModel({
      Id: `group-${index}`,
      Type: new TaskTypeModel({
        Id: item.TypeId,
        Name: item.TypeName,
      }),
      Count: item.Count,
      Items: item.Items.map((x) => mapGetGroupedTaskListItem(x)),
    });
  });
};

export const mapGetByStatusTaskListRequest = (request: GetByStatusTasksRequestModel) =>
  new GetByStatusTaskListRequest({
    StatusId: request.StatusId,
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Sort: mapSortingSettings(request.Sort),
    Page: mapPageRequest(request.Page),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByStatusTaskListResponse = (response: GetByStatusTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });

export const mapGetByPriorityTaskListRequest = (request: GetByPriorityTasksRequestModel) =>
  new GetByPriorityTaskListRequest({
    PriorityId: request.PriorityId,
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Page: mapPageRequest(request.Page),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByPriorityTaskListResponse = (response: GetByPriorityTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });
export const mapGetByPerformerTaskListRequest = (request: GetByPerformerTasksRequestModel) =>
  new GetByPerformerTaskListRequest({
    PerformerId: request.PerformerId,
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Page: mapPageRequest(request.Page),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByPerformerTaskListResponse = (response: GetByPerformerTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });
export const mapGetByTagTaskListRequest = (request: GetByTagTasksRequestModel) =>
  new GetByTagTaskListRequest({
    TagId: request.TagId,
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Page: mapPageRequest(request.Page),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByTagTaskListResponse = (response: GetByTagTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });
export const mapGetByTypeTaskListRequest = (request: GetByTypeTasksRequestModel) =>
  new GetByTypeTaskListRequest({
    TypeId: request.TypeId,
    QueueTaskId: request.QueueTaskId,
    Sort: mapSortingSettings(request.Sort),
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Page: mapPageRequest(request.Page),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByTypeTaskListResponse = (response: GetByTypeTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });

export const mapGetByOwnerTaskListRequest = (request: GetByOwnerTasksRequestModel) =>
  new GetByOwnerTaskListRequest({
    OwnerId: request.OwnerId,
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    Page: mapPageRequest(request.Page),
    Sort: mapSortingSettings(request.Sort),
    Filter: new GetTaskListRequestFilter({
      Search: request.Search,
      WithoutPriorities: undefined,
      WithoutTags: undefined,
    }),
  });

export const mapGetByOwnerTaskListResponse = (response: GetByOwnerTaskListResponse) =>
  new PageResponseModel<TaskModel>({
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
    Items: response.Items.map((x) => mapGetGroupedTaskListItem(x)),
  });

export const mapGetByParentTaskListRequest = (request: GetByParentTasksRequestModel) =>
  new GetByParentTaskListRequest({
    QueueTaskId: request.QueueTaskId,
    VisibleSettings: mapViewSettings(request.ViewSettings),
    ParentId: request.ParentId,
    Page: new PageRequest({
      Skip: 0,
      Take: 100,
    }),
  });

export const mapGetByParentTaskListResponse = (
  response: GetByParentTaskListResponse,
  parentId?: number,
) => {
  return response.Items.map((x) => mapGetGroupedTaskListItem(x, parentId));
};

export const mapUpdatePriorityRequest = (request: TaskUpdatePriorityModel) =>
  new TaskUpdatePriorityRequest({
    TaskId: request.TaskId,
    PriorityId: request.PriorityId,
  });

export const mapUpdateStatusRequest = (request: TaskUpdateStatusModel) =>
  new TaskUpdateStatusRequest({
    TaskId: request.TaskId,
    StatusId: request.StatusId,
  });

export const mapUpdateTypeRequest = (request: TaskUpdateTypeModel) =>
  new UpdateTaskTypeRequest({
    TaskId: request.TaskId,
    TaskTypeId: request.TaskTypeId,
  });
